import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Grid,
  GridItem,
  Heading,
  Text
} from "@chakra-ui/react";
import { translateSubElementString } from "../../../../../../utils";
import TotalEmissionsGridItems from "./TotalEmissionsGridItems";
import MissingDataGridItems from "./MissingDataGridItems";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  useGetScopeOneConsumptionTypes,
  useGetScopeTwoConsumptionTypes
} from "../../../../../../hooks/query";

function TotalReportGridAccordionItem({ data, title, type }) {
  const { t } = useTranslation("translation");

  const [sectionItems, setSectionItems] = useState([]);

  const {
    data: scopeOneConsumptionTypes
  } = useGetScopeOneConsumptionTypes();

  const {
    data: scopeTwoConsumptionTypes
  } = useGetScopeTwoConsumptionTypes();

  useEffect(() => {
    if (scopeOneConsumptionTypes && scopeTwoConsumptionTypes) {
      let items;

      switch (type) {
        case "stationary":
          items = scopeOneConsumptionTypes.stationaryMobileTypes;
          break;
        case "mobile":
          items = scopeOneConsumptionTypes.stationaryMobileTypes;
          break;
        case "refrigerant":
          items = scopeOneConsumptionTypes.refrigerantTypes;
          break;
        case "electricity":
          items = scopeTwoConsumptionTypes.electricityTypes;
          break;
        default:
          items = [];
      }

      setSectionItems(items);
    }
  }, [scopeOneConsumptionTypes, scopeTwoConsumptionTypes, type]);

  return (
    <AccordionItem>
      {
        ({ isExpanded }) => {
          return <>
            <h2>
              <AccordionButton>
                <Box flex="1" textAlign="left">
                  <Heading color="esg_gray.200" size="xs">
                    {title}
                  </Heading>
                </Box>
                <Text fontSize={"sm"} mr={2}>
                  {isExpanded ? t("buttons.collapse") : t("buttons.expand")}
                </Text>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pt={2} pb={5} overflow="auto">
              <Grid templateColumns="repeat(3, 1fr)" gap={2}>
                <GridItem>
                </GridItem>
                <GridItem>
                  <Heading marginBlock="1" align="right" size="sm">
                    {t("reportsPage.totalConsumption")}
                  </Heading>
                </GridItem>
                <GridItem>
                  <Heading marginBlock="1" align="right" size="sm">
                    {translateSubElementString("reportsPage.totalEmissions")}
                  </Heading>
                </GridItem>
                {!data || !data[type] || sectionItems.length === 0 ?
                  <MissingDataGridItems key={`${type}-missing-items`} value={"n/a"} /> :
                  <TotalEmissionsGridItems data={data} sectionItems={sectionItems} dataType={type}/>
                }
              </Grid>
            </AccordionPanel>
          </>
        }
      }
    </AccordionItem>
  )
}

export default TotalReportGridAccordionItem;